import { useSessionEvents } from '@/hooks/useSessionEvents'

/**
 * Renderless component that opens the app-global `/events` SSE channel and
 * reconciles TanStack Query caches in place as session events arrive.
 *
 * It MUST be mounted (once) by every app that hosts a chat surface. With
 * the always-async model means POST /sessions/{id}/messages returns 202 and the
 * answer is delivered out-of-band as turn.delta / turn.completed events on
 * THIS channel — `useStreamingMessage` only records the pending turn, it does
 * not receive the answer. An app that sends messages but never mounts this
 * subscriber shows an empty "thinking" placeholder forever (the answer is
 * computed and persisted server-side, so a reload reveals it), which reads as
 * "chat does nothing".
 *
 * Lives in the shared component barrel — not copy-pasted per app — so the main
 * frontend and the satellite apps (apps/care-planner, apps/roster, …) share one
 * definition and a new chat-hosting app wires delivery by mounting this single
 * component. The hook self-guards on auth, so it is safe to render
 * unconditionally; it no-ops until there is a session token.
 */
export function SessionEventSubscriber() {
  useSessionEvents()
  return null
}
